export default "__VITE_ASSET__I5Uec2JM__"